function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgData = function SvgData(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M5.92 28.746q.588.587 1.413.587h17.333q.825 0 1.413-.587.587-.588.587-1.413V12.866q0-.824-.587-1.412a1.93 1.93 0 0 0-1.413-.588h-2.333v-3.2q0-2.628-1.85-4.48t-4.48-1.853-4.483 1.853-1.854 4.48v3.2H7.333q-.824 0-1.412.588a1.93 1.93 0 0 0-.588 1.412v14.467q0 .824.588 1.413m18.746-1.413H7.333V12.866h17.333zm-4.333-16.467h-8.667v-3.2q0-1.805 1.267-3.07 1.267-1.263 3.07-1.263 1.804 0 3.067 1.264 1.263 1.263 1.263 3.07z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M16.005 22.666q1.061 0 1.811-.734.75-.735.75-1.766 0-1-.755-1.816-.756-.817-1.817-.817t-1.811.817-.75 1.833.756 1.75 1.816.733"
  }));
};
export default SvgData;